import { formatPhoneNumber } from 'react-phone-number-input';

import LocalBranchMap from 'components/LocalBranchMap/LocalBranchMap';
import FormTitle from 'components/PageLayout/FormTitle';
import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import { getApplyProcessState } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useGetGeocode from 'hooks/useGetGeocode';
import { unFormatBorrowerPhone } from 'utils/curo-helpers/validation';

import BranchInstructions from './BranchInstructions';
import styles from './DMBranchOffer.module.scss';

const DMBranchOffer = () => {
  const { mailOfferData } = useAppSelector(getApplyProcessState);

  const borrowerFirstName = mailOfferData?.firstName;
  const borrowerOfferAmount = mailOfferData?.offerAmount || '';
  const branchPhone = mailOfferData?.branchPhone || '';
  const branchStreet = mailOfferData?.branchAddress || '';
  const branchCity = mailOfferData?.branchCity;
  const branchState = mailOfferData?.branchState;
  const branchZip = mailOfferData?.branchZip;
  const branchCityStateZip = `${branchCity}, ${branchState} ${branchZip}`;

  const { latLng, getDirection } = useGetGeocode({
    branchCityStateZip,
    branchPhone,
    branchStreet,
  });

  const renderContent = () => {
    if (latLng?.lat && latLng.lng) {
      return (
        <div className={styles.rightContainer}>
          <LocalBranchMap
            lat={latLng?.lat}
            lng={latLng?.lng}
            branchCityStateZip={branchCityStateZip}
            branchPhone={formatPhoneNumber(unFormatBorrowerPhone(branchPhone))}
            branchStreet={branchStreet}
          />

          <ButtonWithLoadingState kind="primary" size="form" onClick={getDirection}>
            Get Directions
          </ButtonWithLoadingState>
        </div>
      );
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div>
        <FormTitle title={`Congrats, ${borrowerFirstName}!`} />
        <BranchInstructions offerAmount={borrowerOfferAmount} />
      </div>

      {renderContent()}
    </div>
  );
};

export default DMBranchOffer;
